<template>
    <div id="activities-index-page" class="dashboard-view">
        <div class="container">
            <section class="content">
                <h1>Activities</h1>

                <DataTable class="activities-data-table"
                        :dataUrl="dataUrl"
                        :displayId="false"
                        :key="tableRefreshKey"
                        :dataFormatter="formatData"
                        :predefinedFilters="filtersData">

                    <template v-slot:empty>
                        No records found
                    </template>
                </DataTable>
            </section>
        </div>
    </div>
</template>

<script>
import DataTable from '@/components/global/DataTable.vue'
const endpoint = process.env.VUE_APP_API_BASE + '/activities'
//import axios from 'axios'

export default {
    name: 'ActivitiesIndex',
    components: {
        DataTable
    },
    data: function() {
        return {
            //users: [],
            dataUrl: endpoint,
            tableRefreshKey: null,

            filtersData: {
                "device": this.getDevicesFromUrl()
            }
        }
    },
    methods: {
        getDevicesFromUrl() {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const devicesList = urlParams.getAll('device')
            return devicesList
        },
        formatData(data) {
            const newData = []
            for (let obj of data) {
                const newObj = {}
                for (let key in obj) {
                    const ignore = ['__v']
                    if (ignore.includes(key)) {
                        continue
                    }
                    else if (key === 'device') {
                        if (obj[key]) {
                            newObj['device_obj'] = {
                                'label': 'Device Object',
                                'value': obj[key],
                                'display_type': 'object'
                            }
                        }
                    }
                    else if (key === 'data') {
                        newObj[key] = {
                            'label': key,
                            'value': obj[key],
                            'display_type': 'object'
                        }
                    }
                    else if (key.includes('At')) {
                        newObj[key] = {
                            'label': key,
                            'value': obj[key],
                            'display_type': 'date'
                        }
                    }
                    else {
                        newObj[key] = {
                            'label': key,
                            'value': obj[key],
                            'display_type': 'text'
                        }
                    }
                }

                newData.push(newObj)
            }
            return newData
        },
        /*
        actionTriggered(actionKey, identifier) {

        }
        */
    }
}
</script>

<style lang="scss" scoped>
</style>
